module.exports = __webpack_public_path__ + "static/img/3.f02a2f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/pengu/3.png
// module id = wn0Y
// module chunks = 35